import removeVendorPrefix from "./removeVendorPrefix";
export function matchTransitionProperty(subject, property) {
    if (property === "all") {
        return true;
    }
    var sub = removeVendorPrefix(subject);
    var prop = removeVendorPrefix(property);
    if (sub.length < prop.length) {
        return false;
    }
    else if (sub.length === prop.length) {
        return sub === prop;
    }
    return sub.substr(0, prop.length) === prop;
}
export default matchTransitionProperty;

//# sourceMappingURL=matchTransitionProperty.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-css-transition/lib/utils/matchTransitionProperty.js
// module id = 231
// module chunks = 0